
@switch (status) {
  @case (ScanStatus.Passed) {
    <span nz-icon nzType="check-circle" nzTheme="fill"
      style="color: green" [style.outline]="modified ? '2px solid blue' : '2px solid transparent'"></span>
  }
  @case (ScanStatus.Failed) {
    <span nz-icon nzType="close-circle" nzTheme="fill"
      style="color: red" [style.outline]="modified ? '2px solid blue' : '2px solid transparent'"></span>
  }
  @case (ScanStatus.Ignored) {
    <span nz-icon nzType="question-circle" nzTheme="fill"
      style="color: grey" [style.outline]="modified ? '2px solid blue' : '2px solid transparent'"></span>
  }
  @case (ScanStatus.Scanning) {
    <span nz-icon nzType="camera"
      [style.outline]="modified ? '2px solid blue' : '2px solid transparent'"></span>
  }
  @case (ScanStatus.Inspecting) {
    <span nz-icon nzType="search"
      [style.outline]="modified ? '2px solid blue' : '2px solid transparent'"></span>
  }
  @case (ScanStatus.Bypassed) {
    <span nz-icon nzType="eye-invisible"
      [style.outline]="modified ? '2px solid blue' : '2px solid transparent'"></span>
  }
}
